/** @jsxImportSource @emotion/react */
import React, { useEffect, useState } from 'react';
import SelectedValue from '../selected-value/selected-value.component';
import chevronRightIcon from '../../../../../assets/chevron-right.svg';
import { filterStyles } from './pricing-filter.styles';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Switch } from '@mui/material';
import { selectLocationsParams } from '../../../../../store/locations/locations-list.selector';
import { BooleanParam, useQueryParams } from 'use-query-params';
import {
    setLocationsParamsIsFree,
    setLocationsParamsIsPaid,
} from '../../../../../store/locations/locations-list.slice';

const PricingFilter = () => {
    const intl = useIntl();
    const [isOpen, setIsOpen] = useState(false);
    const dispatch = useDispatch();
    const searchFilters = useSelector(selectLocationsParams);
    const [query, setQuery] = useQueryParams({
        isFree: BooleanParam,
        isPaid: BooleanParam,
    });

    useEffect(() => {
        if (query.isFree) {
            dispatch(setLocationsParamsIsFree(query.isFree));
        }
        if (query.isPaid) {
            dispatch(setLocationsParamsIsPaid(query.isPaid));
        }
    }, []);

    const changePaidFilter = () => {
        const newValue = !searchFilters.isPaid;
        dispatch(setLocationsParamsIsPaid(newValue));
        setQuery({ isPaid: newValue || undefined });
    };

    const changeFreeFilter = () => {
        const newValue = !searchFilters.isFree;
        dispatch(setLocationsParamsIsFree(newValue));
        setQuery({ isFree: newValue || undefined });
    };

    return (
        <div css={filterStyles.root}>
            <div css={filterStyles.topBlock}>
                <div css={filterStyles.headerWrapper}>
                    <span css={filterStyles.title}>{intl.formatMessage({ id: 'pricing' })}</span>
                    <div css={filterStyles.valuesWrapper}>
                        {searchFilters.isFree && (
                            <SelectedValue
                                value={`${intl.formatMessage({ id: 'freeCharging' })}`}
                                onRemove={changeFreeFilter}
                            />
                        )}
                        {searchFilters.isPaid && (
                            <SelectedValue
                                value={`${intl.formatMessage({ id: 'paidCharging' })}`}
                                onRemove={changePaidFilter}
                            />
                        )}
                    </div>
                </div>
                <img
                    css={
                        isOpen
                            ? [filterStyles.chevronIcon, filterStyles.chevronIconOpen]
                            : filterStyles.chevronIcon
                    }
                    src={chevronRightIcon}
                    alt="chevron-right"
                    onClick={() => setIsOpen(!isOpen)}
                />
            </div>
            {isOpen && (
                <div css={filterStyles.contentWrapper}>
                    <div css={filterStyles.filtersWrapper}>
                        <span css={filterStyles.filterItemLabel}>
                            {intl.formatMessage({ id: 'freeCharging' })}
                        </span>
                        <Switch checked={searchFilters.isFree} onChange={changeFreeFilter} />
                    </div>
                    <div css={filterStyles.filtersWrapper}>
                        <span css={filterStyles.filterItemLabel}>
                            {intl.formatMessage({ id: 'paidCharging' })}
                        </span>
                        <Switch checked={searchFilters.isPaid} onChange={changePaidFilter} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default PricingFilter;
